
	
const columnList: Array<any> = [
    {
        prop: "create_time_text",
        label: "日期",
        width: 150,
    },
    {
        prop: "status_text",
        label: "类型",
        width: 100,
    },
    {
        prop: "name",
        label: "操作员账号",
        width: 150,
    },
    {
        prop: "nickname",
        label: "名字",
        width: 150,
    },

];
import {Request} from '@/api/request';

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {getExpenditureDetail, getPurchaseTable, getSupplierList, gteIncomeDetail} from "@/api/http";
import { column } from "@/assets/types/common";

export default defineComponent({
    name: "operationLogList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["操作日志"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            total = ref(0),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            danjudialog_show = ref(false),
            detailTable = ref([] as Array<any>),
            detailInfo = reactive({} as any),
            screenParameter =  ref({
                time: null,
                page: currentPage.value,
              pagesize: pageSize.value,
                search: "",
				status: null,
                start_date: null,
                end_date: null
            } as any),
 
			dialog_show = ref(false),
			form_isload = ref(false),
			form = ref({
				name: '',
				phone: '',
				nickname: '',
				position_id: '',
				branch_id: '',
				role_id: '',
				gender: '',
				qq: '',
				wechat: '',
				email: '',
				identity_number: '',
				address: '',
				entry_time: ''
			} as any),
            formRef = ref(null),
			formRules = {
				name: [{ required: true, message: '必填', trigger: 'blur'}],
				role_id: [{ required: true, message: '必填', trigger: 'changle'}],
				gender: [{ required: true, message: '必填', trigger: 'changle'}],
				nickname: [{ required: true, message: '必填', trigger: 'blur'}],
				position_id: [{ required: true, message: '必填', trigger: 'changle'}],
				branch_id: [{ required: true, message: '必填', trigger: 'changle'}],
			},
			form_positionList = ref([]),
			form_branchList = ref([]),
			form_roleList = ref([]),
			_addstaff = (): void => {
				dialog_show.value = true
				form_isload.value = true
				
				
				Request.axiosInstance({
					url: 'adminapi/Position/list',
					data: {status: 1}
				}).then((res: any) => {
					form_positionList.value = res?.content?.list || []
					Request.axiosInstance({
						url: 'adminapi/Role/list',
					}).then((res: any) => {
						form_roleList.value = res?.content?.list || []
						form_isload.value = false
					})
					
				})
			
				
			},
            screenChange = (e: any , key: any): void => {

                screenParameter.value.start_date = e[0] ? new Date(e[0]).getTime()/1000 : null;
                screenParameter.value.end_date = e[1] ? new Date(e[1]).getTime()/1000 : null;
                
                getTableData();
            },
			_uprowStatus = (id: number, status: number): void => {
				loading.value = true
				Request.axiosInstance({
					url: 'adminapi/Admin/upStateAdminStaff',
					data: {id: id, status: (status == 0 ? 1 : 0)}
				}).then((res: any) => {
					getTableData()
				})
			},
			_resetPassword = (id: number) => {
				
				if(!confirm("是否将该用户重置密码为123456")) return
				loading.value = true
				Request.axiosInstance({
					url: 'adminapi/Admin/resetPassword',
					data: {id: id}
				}).then((res: any) => {
					loading.value = false
				})
			},
            danjudetail_click = (index:number) => {
            let item = tableData.value[index];
              if (item.type==1){
                  getExpenditureDetail({expenditure_id:item.party_id}).then((res:any)=>{
                      detailInfo = res.content;
                      showDetail(detailInfo);
                  });
              }else {
                  gteIncomeDetail({income_id:item.party_id}).then((res:any)=>{
                      detailInfo = res.content;
                      showDetail(detailInfo);
                  });
              }
              
            },
            showDetail = ((detailInfo:any)=>{
                danjudialog_show.value = true;
                let arr = [[
                    '收入日期',
                    detailInfo.income_time_text,
                    '收入类型',
                    detailInfo.income_collection_text,
                    '类别',
                    detailInfo.expenditure_type,
                    '关联单据',
                    detailInfo.ordersn,
                ],[
                    '创建时间',
                    detailInfo.create_time_text,
                    '创建人',
                    detailInfo.admin,
                    '状态',
                    detailInfo.toexamine,
                    '审核时间',
                    detailInfo.audit_time,
                ],[
                    '审核人',
                    detailInfo.admin,
                    '金额',
                    detailInfo.income_price,
                    '收款方式',
                    detailInfo.income_type_text,
                    '付款方',
                    detailInfo.income_payer,
                ],[
                    '联系电话',
                    detailInfo.income_phone,
                    '经手人',
                    detailInfo.admin,
                    '备注',
                    detailInfo.income_desc,
                ]];
                detailTable.value = arr;
            }),
            handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
              loading.value = true;
              Request.axiosInstance({
                url: 'adminapi/Admin/operationLogList',
                data: screenParameter.value
              }).then((res: any) => {
                tableData.value = res?.content?.list || [];
                loading.value = false;
                total.value = res?.content?.total || 0;
              })
            },
          
            selectChange = (e: number): void => {
				console.log(e);
                getTableData();
            }

        onMounted(() => {
			Request.axiosInstance({
				url: 'adminapi/Branch/list',
				data: {status: 1}
			}).then((res: any) => {
				form_branchList.value = res?.content?.list || []
				getTableData();
			})
            
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            screen,
            screenParameter,
            selectChange,
			dialog_show,
            total,
            pageSize,
            currentPage,
			handleSizeChange,
			handleCurrentChange,
			form,
			formRef,
			formRules,
			form_isload,
			form_positionList,
			form_branchList,
			form_roleList,
			_addstaff,
			_uprowStatus,
			_resetPassword,
            screenChange,
          danjudialog_show,
          detailTable,
            detailInfo,
            showDetail,
          danjudetail_click
        };
    },
});
